export const isValidCustomerId = (customerId: number | null | undefined): boolean => {
  return typeof customerId === 'number' && Number.isInteger(customerId);
}